import SlideshowGreetingView from './SlideshowGreetingView';

export default SlideshowGreetingView;
